export const SET_PUBLIC_KEY = "SET_PUBLIC_KEY";

export const setPublicKey = (payload) => (dispatch) => {
  return dispatch({ type: SET_PUBLIC_KEY, payload });
};